export const BOTIMZA_BASE_URL = 'https://www.botimza.com';
export const BOTIMZA_QUERY_PARAM = 'q';
export const REF_QUERY_PARAM = 'r';
export const REF_SHARE_BUTTON = 'btn';
export const REF_TELEGRAM_MSG = 'pst';
export const REF_INFO_PAGE = 'info';
// Internal cross-links between search/info pages themselves (RelatedGuides,
// RelatedSearches, PopularSearches, the /search hub) - docs/ssr-seo-distribution-plan.md
// Phase 3 item 5. Distinguishes organic on-site discovery from Telegram/Facebook/info-page
// referrals in Mixpanel's "Page View" referrer breakdown.
export const REF_RELATED_SEARCH = 'rel';


